import NotificationRuleActionContactMembership from "./NotificationRuleActionContactMembership";
import { v4 as uuidv4 } from "uuid";

export default interface NotificationRuleAction {
    notificationRuleActionId?: number;
    title: string;
    notificationRuleId?: number;
    tenantId?: number;
    sendTo: NotificationRuleActionContactMembership[];

    /* Used by v-for when dynamically assigning new Actions */
    key?: string;
}

export const DefaultNotificationRuleAction: NotificationRuleAction = {
    key: uuidv4(),
    title: "",
    sendTo: [],
    notificationRuleId: null,
    tenantId: null
}